import { useEffect, useState } from "react";
import useRequest from "./use-req";

export interface WabaAccountOption {
  value: string;
  label: string;
}

// GET /whatsapp/accounts — returns the org's connected WhatsApp Business
// Accounts, e.g. { status, message, data: [{ waba_id, waba_name, is_active, ... }] }.
// `waba_id` (Meta's WABA id) is what the backend expects back on template
// create — not the row's own `id` — and `waba_name` is the display label.
export default function useWhatsappAccounts() {
  const token = localStorage.getItem("authToken");
  const [wabaAccounts, setWabaAccounts] = useState<WabaAccountOption[]>([]);
  const { makeRequest: getWhatsappAccounts, loading } = useRequest("/whatsapp/accounts", "GET", {
    Authorization: `Bearer ${token}`,
  });

  useEffect(() => {
    (async () => {
      const [response] = await getWhatsappAccounts();
      const rows: any[] = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      setWabaAccounts(
        rows
          .filter((row) => row?.waba_id && row?.is_active !== false)
          .map((row) => ({ value: row.waba_id, label: row.waba_name || row.waba_id }))
      );
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { wabaAccounts, loading };
}
